import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import PropTypes from "prop-types";
import { ROLL_CALL_API_BASE_URL } from "../../RollCall/RollCallConfig/RollCallConfig";
import { Spin } from "antd";
const EditEvent = ({ fetchVisitorEvents, onClose, isOpen, eventData }) => {
  const [eventName, setEventName] = useState("");
  const [eventNote, setEventNote] = useState("");
  const [eventCount, setEventCount] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
    }
  }, []);

  useEffect(() => {
    if (eventData) {
      setEventName(eventData.Name || "");
      setEventNote(eventData.Note || "");
      setEventCount(eventData.Count || "");
      setEventDate(eventData.EventDate || "");
    }
  }, [eventData]);

  const handleUpdate = async (e) => {
    e.preventDefault();

    setLoading(true);

    const userData = JSON.parse(sessionStorage.getItem("userData"));

    const payload = {
      Id: eventData.Id,
      Name: eventName,
      Note: eventNote,
      Count: Number(eventCount),
      VisitType: 6,
      EventDate: eventDate,
      SuperId: Number(superIdData),
      UpdatedBy: userData?.UserId,
    };

    try {
      const response = await fetch(
        `${ ROLL_CALL_API_BASE_URL }Visitor/Pass/updateVisitorEvent`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenData}`,
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();

      if (result?.status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Event updated successfully",
        }).then(() => {
          fetchVisitorEvents();
          onClose();
        });
      } else {
        Swal.fire(
          "Error",
          result?.message || "Failed to update event",
          "error",
        );
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Something went wrong", "error");
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    setEventName("");
    setEventNote("");
    setEventCount("");
  };
  useEffect(() => {
    const offcanvasEl = document.getElementById("offcanvasRightAddEvent");

    const handleOffcanvasClose = () => {
      handleCancel();
    };

    if (offcanvasEl) {
      offcanvasEl.addEventListener("hidden.bs.offcanvas", handleOffcanvasClose);
    }

    return () => {
      if (offcanvasEl) {
        offcanvasEl.removeEventListener(
          "hidden.bs.offcanvas",
          handleOffcanvasClose,
        );
      }
    };
  }, []);
  const handleClose = () => {
    handleCancel();
    onClose();
  };
  return (
    <>
      {isOpen && (
        <div>
          {loading && (
            <div
              className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
              style={{
                zIndex: 1050,
                backdropFilter: "blur(4px)",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              }}
            >
              <Spin size="large" tip="Processing..." />
            </div>
          )}
          <style>
            {`
        @media (max-width: 576px) {
          #offcanvasRightAddEvent {
            width: 90% !important;
          }
        }

        @media (min-width: 577px) and (max-width: 992px) {
          #offcanvasRightAddEvent {
            width: 55% !important;
          }
        }

        @media (min-width: 993px) and (max-width: 1440px) {
          #offcanvasRightAddEvent {
            width: 32% !important;
          }
        }
          
       @media (min-width: 1441px) and (max-width:2550px) {
          #offcanvasRightAddEvent {
            width: 20% !important;
          }
        }
        @media (min-width:2551px) {
          #offcanvasRightAddEvent {
            width:15% !important;
          }
        }
        `}
          </style>

          <div className="offcanvas-backdrop fade show" onClick={handleClose} />

          <div
            className="offcanvas offcanvas-end show"
            id="offcanvasRightAddEvent"
            style={{ visibility: "visible" }}
          >
            <div className="offcanvas-header">
              <h4>Add Event</h4>
              <button
                type="button"
                className="btn-close text-reset"
                onClick={handleClose}
                aria-label="Close"
              />
            </div>
            <hr className="m-0 p-0" />
            <div className="offcanvas-body">
              <form onSubmit={handleUpdate}>
                <div className="content">
                  <div className="row">
                    <div className="mb-3">
                      <label className="form-label">
                        <span className="text-danger ms-1">*</span> Event Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter event name"
                        value={eventName}
                        onChange={(e) => setEventName(e.target.value)}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Notes</label>
                      <textarea
                        className="form-control"
                        rows="3"
                        placeholder="Enter event note"
                        value={eventNote}
                        onChange={(e) => setEventNote(e.target.value)}
                      />
                    </div>

                    <div className="mb-3 col-6">
                      <label className="form-label">
                        <span className="text-danger ms-1">*</span> Count
                      </label>
                      <input
                        type="number"
                        min="1"
                        className="form-control"
                        placeholder="Enter visitor count"
                        value={eventCount}
                        onChange={(e) => setEventCount(e.target.value)}
                        required
                      />
                    </div>
                    <div className="mb-3 col-6">
                      <label className="form-label">
                        <span className="text-danger ms-1">*</span> Event Date
                      </label>
                      <input
                        type="date"
                        min="1"
                        className="form-control"
                        placeholder="Enter visitor Date"
                        value={eventDate}
                        onChange={(e) => setEventDate(e.target.value)}
                        required
                      />
                    </div>
                  </div>

                  <div className="row d-flex justify-content-end mt-3">
                    <div
                      className="col-3 d-flex justify-content-end"
                      style={{ marginRight: "20px" }}
                    >
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-bs-dismiss="offcanvas"
                        aria-label="Close"
                        onClick={handleClose}
                      >
                        Cancel
                      </button>
                    </div>

                    <div className="col-2 d-flex justify-content-end">
                      <button type="submit" className="btn btn-success">
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
EditEvent.propTypes = {
  fetchVisitorEvents: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  eventData: PropTypes.object,
};
export default EditEvent;
